import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import './App/css/bootstrap.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
